/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DataUtils = {
  arrayEquals: function arrayEquals(arr1, arr2) {
    return !arr1.some(function (a) {
      return !arr2.includes(a);
    });
  },
  sort: function sort() {
    var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var sortToEnd = arr.length;

    if (Array.isArray(arr)) {
      return arr.sort(function (a, b) {
        var _a, _b;

        var aSortOrder = (_a = a.sortOrder) !== null && _a !== void 0 ? _a : sortToEnd;
        var bSortOrder = (_b = b.sortOrder) !== null && _b !== void 0 ? _b : sortToEnd;
        return aSortOrder - bSortOrder;
      });
    }

    return arr;
  }
};
exports.default = DataUtils;